export enum NetsuiteCloseReturnAuthorizationPermissionType {
  CLOSE = "close",
  AUTOMATION = "automation",
}

export const NetsuiteCreditMemoSources = ["rma", "invoice"] as const;
export type NetsuiteCreditMemoSource =
  (typeof NetsuiteCreditMemoSources)[number];

export type FieldValueType = "string" | "number";

export interface NetSuiteCustomField {
  fieldKey: string;
  fieldValue: string | NetSuiteCustomField[];
  valueType?: FieldValueType;
}

export const ALLOWED_DYNAMIC_VARIABLES_ON_LINE_ITEM = [
  "primaryReturnReason",
  "secondaryReturnReason",
  "primaryReasonCode",
  "secondaryReasonCode",
  "isGreenReturn",
  "compensationType",
  "refundAmount",
  "storeCreditAmount",
  "lineItemId",
  "comments",
] as const;

export const ALLOWED_DYNAMIC_VARIABLES_ON_RMA = [
  "trackingNumber",
  "carrierName",
  "compensationType",
  "exchangeAmount",
  "exchangeType",
  "storeCredit",
  "refundTotal",
  "orderId",
  "providerOrderName",
  "redoReturnId",
  "redoPortalUrl",
] as const;

export type NetSuiteExchangeType =
  | "upsellExchange"
  | "evenExchange"
  | "downsellExchange";

export const ALLOWED_DYNAMIC_VARIABLES_ON_RATE_AMOUNT_TEMPLATE = [
  "exchangeCredit",
  "storeCreditAmount",
  "deductedShippingFee",
  "finalizeFlowAdjustment",
] as const;

export const NETSUITE_ACCOUNT_ID_FORMAT_ERROR_MESSAGE =
  "Non-production account IDs must use an uppercase, underscore-prefixed environment suffix: `_SB<number>` for sandbox (e.g. `1234567_SB1`, `1234567_SB2`) or `_RP` / `_RP<number>` for release preview (e.g. `1234567_RP`, `1234567_RP1`).";

const VALID_NETSUITE_ENV_SUFFIX = /(?:_SB\d+|_RP\d*)$/;
const SUSPICIOUS_NETSUITE_ENV_SUFFIX = /sb\d|rp/i;

export function getNetSuiteAccountIdErrorMessage(
  accountId: string,
): string | undefined {
  const trimmed = accountId.trim();
  if (trimmed === "") {
    return undefined;
  }
  if (VALID_NETSUITE_ENV_SUFFIX.test(trimmed)) {
    return undefined;
  }
  if (SUSPICIOUS_NETSUITE_ENV_SUFFIX.test(trimmed)) {
    return NETSUITE_ACCOUNT_ID_FORMAT_ERROR_MESSAGE;
  }
  return undefined;
}
